import React, { FunctionComponent } from 'react';

import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
} from '@mui/material';

import { isEmpty, map } from 'lodash';

import { Model } from '../../types/models';

import { ProfileProps, withProfile } from './AuthController';

interface Props extends ProfileProps {
  models?: Model[];
  modelId?: number;
  onChange(modelId: number): void;
  size?: 'small' | 'medium';
}

const SelectModelForCopyScenario: FunctionComponent<Props> = ({
  models,
  modelId,
  onChange,
  size = 'medium',
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    onChange(parseInt(event.target.value, 10));
  };

  return (
    <FormControl size={size} fullWidth>
      <InputLabel id="select-model-label">
        {isEmpty(models) ? 'No Models found' : 'Select a Model'}
      </InputLabel>
      <Select
        labelId="select-model-label"
        id="select-model"
        value={String(modelId)}
        label={isEmpty(models) ? 'No Models found' : 'Select a Model'}
        onChange={handleChange}
        fullWidth
      >
        {map(models, (model) => (
          <MenuItem key={model.id} value={String(model.id)}>
            {model.Name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default withProfile(SelectModelForCopyScenario);
